import { ReactElement } from 'react';
import RuleLibrary from 'pages/campaign/iteration/[iterationId]/RuleLibrary';
import RulePage from 'pages/campaign/iteration/[iterationId]/Rule';

const createFilterRuleRoutes = (withCampaignLoader: (component: ReactElement) => ReactElement) => ({
  path: 'filter-rules',
  children: [
    {
      path: ':ruleId',
      element: withCampaignLoader(<RulePage ruleTypeFromRoute="F" />),
      children: [
        {
          path: 'and-clause/:andClauseNumber',
          element: withCampaignLoader(<RulePage ruleTypeFromRoute="F" />),
        },
      ],
    },
    { path: ':ruleId/library', element: withCampaignLoader(<RuleLibrary ruleType="F" />) },
    { path: ':ruleId/and-clause/:andClauseNumber/library', element: withCampaignLoader(<RuleLibrary ruleType="F" />) },
  ],
});

export default createFilterRuleRoutes;
